import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'

import validationService from "data/validate"
import { ValidationIcon } from "images/icons/header"
import { ValidationIcon_s } from "components/asset-management/asset-list/asset-list-styles"

export const Errors = (props) => {
  const [show, setShow] = useState<boolean>(false)
  useEffect(() => {
    const validationSubscription = validationService.stream().subscribe((_errors) => {
      const hasErrors = _.some((validationService.filteredValue()).errordetail, (errors, _resource) => !_.isEmpty(errors))
      setShow(hasErrors)
    })
    return () => {
      validationSubscription.unsubscribe()  
    }
  },[props])
    return show ? <a onClick={()=>validationService.displayValidationErrors()}>
      <ValidationIcon_s src={ValidationIcon} width="20px" />
    </a> : null
  }


